module.exports = __webpack_public_path__ + "img/settings_active.d10f64a.svg";